import * as Types from '../../constants/actionTypes';

const defaultState = {
    isPending: false,
    requestList: [],
    statusData: [],
    statuslist : [],
    error:'',
    requestCount: 0,
    programData: {},
    requestYears: [],
    requestStatuses: [],
    requestListCount: 0,
    dashboardSummary: null,
    requestFilterOptions: {
        statuses: [],
        countries: [],
        requestTypes: []
    }
};

export const allRequest = (state = defaultState, action)=>{
    switch(action.type){
        case Types.REQUEST_LIST:
            return Object.assign({}, state, {isPending : true})
        case Types.REQUEST_LIST_SUCCESS:
            return Object.assign({}, state, {
                requestList: action.payload,
                isPending: false,
                additionalData: action.additionalData,
                requestYears: action.requestYears,
                requestStatuses: action.requestStatuses,
                requestListCount: action.requestListCount,
                allRequestData: action.allRequest,
                ...(action.dashboardSummary !== undefined
                    ? { dashboardSummary: action.dashboardSummary }
                    : {}),
            })    
        case Types.REQUEST_LIST_ERROR:
            return Object.assign({}, state, {error: action.payload, isPending:false})
        case Types.REQUEST_COUNT_SUCCESS:
            return Object.assign({}, state, {requestCount: action.payload?.count})
        case Types.REQUEST_COUNT_ERROR:
            return Object.assign({}, state, {requestCount: 0})
        case Types.REQUEST_FILTER_OPTIONS_SUCCESS:
            return Object.assign({}, state, {requestFilterOptions: {
                statuses: action.payload?.statuses,
                countries: action.payload?.countries,
                requestTypes: action.payload?.requestTypes
            }})
        case Types.REQUEST_FILTER_OPTIONS_ERROR:
            return Object.assign({}, state, {requestFilterOptions: {
                statuses: [],
                countries: [],
                requestTypes: []
            }})
        case Types.PROGRAM_DATA:
                return {
                    ...state,
                    programData: action.programData
        }
        case Types.REQUEST_IDS_SUCCESS:
            return {
                ...state,
                requestIds: action.requestIds
            }
        case Types.PROGRAM_ERROR:
            return {
                ...state,
                programError: action.programError
            }
        case Types.STATUSES_DATA:
            return {
                ...state,
                statusData: action.statusData
            }
        case Types.STATUSES_LIST:
            return {
                ...state,
                statusList : action.statusList
            }
        case Types.STATUSES_ERROR:
            return {
                ...state,
                statusError: action.statusError
            }
        case Types.REQUEST_STATUS_DATA:
                return {
                    ...state,
                    listStatusData: action.listStatusData.data,
                    listStatusCount: action.listStatusData.statusCount
                }
        case Types.REQUEST_STATUS_ERROR:
                return {
                    ...state,
                    statusErr: action.statusError
                }
        case Types.PORTAL_ERROR:
            return {
                ...state,
                portalError: action.portalError
            }
        case Types.SET_PORTAL_LOGO:
             return {
                 ...state,
                 [action.portalLogoName]: action.selectedPortalLogo
             }
        case Types.CHART_REQUEST_STATUS_SUCCESS:
            return {
                ...state,
                requestStatusChart:action.payload
            } 
        case Types.CHART_REQUEST_TYPE_SUCCESS:
            return {
                ...state,
                typeChart:action.payload
            } 
        case Types.LIST_ALL_PO:
            return {
                ...state,
                podetailList:action.poList
            }
        case Types.PO_DETAIL_DATA:
            return{
                ...state,
                onePodetails : action.onePodetails
        }  
        case Types.GET_ASSETS_COUNT_DATA:
            return{
                ...state,
                requestAssetsList : action.payload
        }                 
        default : 
            return state   
    }
}
